import React, { FC, useRef } from "react";
import type { ContentfulLeaderType } from "@/types";
import { Image } from "../image";
import { ContentManager } from "../content-manager";
import { set } from "lodash";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

export const LeadershipLeader: FC<ContentfulLeaderType> = (leader) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  const [showMore, setShowMore] = React.useState(false);

  return (
    <div className="leadershipLeader">
      <Image
        src={leader.image as any}
        alt={leader.name}
        className="leadershipLeader--image"
        animateInView
      />
      <div ref={ref} className="leadershipLeader--role">
        {leader.role}
      </div>
      <SplitTextAnimation
        htmlElement={
          <h2
            id={`${leader.name.toLowerCase().replace(/ /g, "-")}`}
            className="leadershipLeader--name"
          >
            {leader.name}
          </h2>
        }
        isInView={isInView}
      />
      <ContentManager
        content={leader.description}
        className="leadershipLeader--description"
      />
      {leader.linkedIn && (
        <a
          href={leader.linkedIn}
          target="_blank"
          rel="noopener noreferrer"
          className="leadershipLeader--linkedIn"
        >
          <svg
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.71955 4.37598C8.78257 4.37598 9.80205 4.79826 10.5537 5.54993C11.3054 6.3016 11.7277 7.32108 11.7277 8.3841V13.0602H9.05559V8.3841C9.05559 8.02976 8.91483 7.68993 8.66427 7.43938C8.41371 7.18882 8.07389 7.04806 7.71955 7.04806C7.36521 7.04806 7.02538 7.18882 6.77482 7.43938C6.52427 7.68993 6.38351 8.02976 6.38351 8.3841V13.0602H3.71143V8.3841C3.71143 7.32108 4.13371 6.3016 4.88538 5.54993C5.63705 4.79826 6.65653 4.37598 7.71955 4.37598Z"
              fill="#020611"
            />
            <path
              d="M2.94796 5.04443H0.275879V13.0607H2.94796V5.04443Z"
              fill="#020611"
            />
            <path
              d="M1.61192 3.04025C2.34979 3.04025 2.94796 2.44208 2.94796 1.7042C2.94796 0.96633 2.34979 0.368164 1.61192 0.368164C0.874045 0.368164 0.275879 0.96633 0.275879 1.7042C0.275879 2.44208 0.874045 3.04025 1.61192 3.04025Z"
              fill="#020611"
            />
          </svg>
        </a>
      )}
      {leader.moreContent && leader.moreContent.length > 0 && (
        <div className="leadershipLeader--more">
          <button
            className={`leadershipLeader--more-toggler ${
              showMore ? "active" : ""
            }`}
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            <span>More about {leader.name.split(" ")[0]}</span>
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="28" cy="28" r="28" fill="#1257D4" />
              <path d="M28 16L28 40" stroke="white" strokeWidth="1.5" />
              <path d="M40 28L16 28" stroke="white" strokeWidth="1.5" />
            </svg>
          </button>
          {showMore && (
            <ContentManager
              content={leader.moreContent}
              className="leadershipLeader--more-content"
            />
          )}
        </div>
      )}
    </div>
  );
};
